import { FooterNavigation as BaseFooterNavigation } from '@connected/ui/features/navigation';
import { useTranslation } from 'react-i18next';

import type { LinkRoute } from '@/config/navigation-config';

import { usePrevNextNavigation } from '@/hooks/use-navigation';

// ============================================================================
// Component
// ============================================================================

/**
 * Renders Section.Footer with automatic prev/next links based on current route.
 */
export function FooterNavigation({ children }: { children?: React.ReactNode }) {
    const { t } = useTranslation('navigation');

    return (
        <BaseFooterNavigation
            usePrevNextNavigation={usePrevNextNavigation}
            renderLabel={(route: LinkRoute) => t(route.name)}
            children={children}
        />
    );
}
